import jwtDecode from 'jwt-decode';

export default class UserService {
  static authorizedPermission = process.env.REACT_APP_PERMISSION?.split(',');

  static getUserInfo() {
    return JSON.parse(sessionStorage.getItem('user_info') ?? '{}');
  }

  static isAuthorized() {
    return this.getUserPermission();
  }

  static getTokens() {
    return JSON.parse(sessionStorage.getItem('access_token') ?? '{}');
  }

  static getUserId() {
    return sessionStorage.getItem('user_id');
  }

  static hasPermission(permission) {
    const userPermission = this.getUserPermission();
    return userPermission.includes(permission);
  }

  static getUserPermission() {
    const userInfo = this.getUserInfo();
    return !!userInfo.cn;
  }

  static displayName() {
    const userInfo = this.getUserInfo();
    return `${userInfo.preferred_username} (${userInfo.cn})`;
  }

  static displayCn() {
    const userInfo = this.getUserInfo();
    return `${userInfo.preferred_username} (${userInfo.cn})`;
  }
  static getCn() {
    const userInfo = this.getUserInfo();
    return userInfo.cn;
  }

  static getUserName() {
    const userInfo = this.getUserInfo();
    return `${userInfo.preferred_username}`;
  }

  static getUserDeptId() {
    return this.getUserInfo().departmentId;
  }

  static decodeToken(token) {
    if (!token) {
      return null;
    }
    try {
      return jwtDecode(token);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  static isTokenExpired(token) {
    if (!token) {
      return true;
    }
    const decodedToken = this.decodeToken(token);
    if (!decodedToken) {
      // Token is invalid or cannot be decoded
      return true;
    }
    const expirationTime = decodedToken.exp * 1000;
    // Check if the current time is after the token expiration time
    return Date.now() >= expirationTime;
  }

  static isAuthenticated() {
    const authTokenString = sessionStorage.getItem('accessToken');
    if (!authTokenString) {
      return false;
    }
    const authToken = JSON.parse(authTokenString);
    return authToken?.accessToken && !this.isTokenExpired(authToken.accessToken);
  }
}
